import { useOutletContext, useParams } from "react-router-dom";

import Unauthorized from "../../ui/components/Unauthorized/Unauthorized";

import useHasRight from "../../authorization/hooks/useHasRight";

import AgreementView from "../views/AgreementView/AgreementView";

export default function Agreement() {
	const { id } = useParams();
	// Super admin routes have no organization context.
	const { organization } = useOutletContext() || {};

	const hasRight = useHasRight();

	if (!hasRight("agreements.view")) {
		return <Unauthorized />;
	}

	return <AgreementView id={id} organization={organization} />;
}
